import React, { useState, useEffect } from "react";

import { ParallaxProvider, ParallaxBanner } from "react-scroll-parallax"; 
import Lottie from "lottie-react";

// 1. Import all the necessary components for the page
import Navbar from "../sections/Navbar";
import HeroSlider from "../components/HeroSlider";
import ServicesSection from "../sections/ServicesSection";
import StoreSection from "../sections/StoreSection";
import Quote from "../sections/Quote";
import MenuSection from "../sections/MenuSection";
import CtaSection from "../sections/CtaSection";
import Footer from "../sections/Footer";
import OpenerAnimation from "../sections/OpenerAnimation";
import AnimatedSection from "../sections/AnimatedSection";
import RevealText from "../components/RevealText"; 
import FeatureImageSection from '../sections/FeatureImageSection';
import yourImage from '../assets/images/your-full-width-image.png';
import heroVideo from "../assets/video/hero-video.mp4";
import icedAmericanoImage from '../assets/images/iced-americano-banner.png';

const HomeScreen = () => {
  const [showOpener, setShowOpener] = useState(
    !sessionStorage.getItem("hasVisited")
  );

  useEffect(() => {
    if (showOpener) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [showOpener]);

  // Data for the quote component can live here
  const brandQuote = {
    script:
      "We curate only the world's top coffee, lots scoring 85+ by certified Q Graders, placing them in the elite “Exceptional” tier.",
    normal:
      "Sourced directly from farmers, roasted with precision, and brewed to honor the journey from seed to cup.",
    author: "GRAMS",
  };
  const brandQuote2 = {
    script:
      "Our menu represents months of tasting, testing, and perfecting. Each drink is selected for its unique characteristics, roasted to highlight its best qualities, and prepared with precision by our skilled baristas.",
    normal:
      "We believe great coffee shouldn't be complicated, just honest, expertly crafted beverages that let the coffee speak for itself. Taste the difference that care and expertise make.",
    author: "GRAMS",
  };

  const handleAnimationFinish = () => {
    // --- NEW: When the animation finishes, set the sessionStorage item ---
    sessionStorage.setItem("hasVisited", "true");
    setShowOpener(false);
  };

  // If showOpener is true, we only render the animation
  if (showOpener) {
    // Pass the new handler to the component
    return <OpenerAnimation onFinished={handleAnimationFinish} />;
  }

  return (
    // 2. Use a React Fragment to wrap all page elements
    <>
    
      <Navbar />

      {/* This is the original hero section content from the old HomeScreen */}
      <div className="hero-container">
    {/* <video autoPlay loop muted playsInline className="hero-video">
      <source src={heroVideo} type="video/mp4" />
      Your browser does not support the video tag.
    </video> */}
    <HeroSlider />
    {/* <div className="hero-text">
      <h1>Brand Built On Quality</h1>
      <p>Proudly Prepared With care</p>
    </div> */}
  </div>

      {/* 3. Render all the other sections in order */}
      <AnimatedSection delay={0.35}>
        <ServicesSection />
      </AnimatedSection>

      <AnimatedSection>
        <StoreSection />
      </AnimatedSection>

      <AnimatedSection delay={0.35}>
        <Quote
          scriptText={brandQuote.script}
          normalText={brandQuote.normal}
          author={brandQuote.author}
        />
      </AnimatedSection>

      <AnimatedSection delay={0.35}>
        
        <FeatureImageSection 
      image={yourImage} // The image you imported
      title="FREE SANGRIA"
      subtitle="Celebration Drink"
      text="Sangria originates from Spain, where it has long been a symbol of celebration, shared moments, and long joyful nights. Traditionally served during festivals and gatherings, it represents warmth, community, and festive spirit."
      buttonText="See More"
      buttonLink="/menu" // The page the button should link to
    />
      </AnimatedSection>
      <MenuSection />
      <AnimatedSection delay={0.35}>
        <Quote
          scriptText={brandQuote2.script}
          normalText={brandQuote2.normal}
          author={brandQuote2.author}
        />
      </AnimatedSection>


      <FeatureImageSection 
      layout="right" // <-- This is the key
      image={icedAmericanoImage}
      preTitle="Iced"
      title="Americano"
      subtitle="Made by Grams"
      text="espresso diluted with iced water, larger cup and lighter taste"
      buttonText="Discover More About This Drink"
      buttonLink="/menu/md16" // Link to the specific product
    />
      

      <AnimatedSection delay={0.35}>
        <CtaSection />
      </AnimatedSection>

      <Footer />
      
    </>
  );
};

export default HomeScreen;
